let contactsMap;
const initContactsMap = () => {
  const mapEl = document.querySelector('[data-map]');
  const locationsString = mapEl?.dataset?.locations;

  if(mapEl && locationsString) {
    const locations = JSON.parse(locationsString);
    if(locations?.length > 0) {
      let lat = locations[0][0];
      let lng = locations[0][1];
      let initialZoom = 12;
      
      if(locations?.length > 1) {
        lat = (locations[0][0] + locations[1][0]) / 2;
        lng = (locations[0][1] + locations[1][1]) / 2;
        let initialZoom = 8;
      }
      

      const poiIcon = mapEl.dataset.poi;

      if(lat && lng && poiIcon) {
        // CREATE MAP
        contactsMap = L.map(`contacts_map`, {
          scrollWheelZoom: false
        }).setView([lat, lng], initialZoom);

        // ADD TILE LAYER TO MAP
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 22 }).addTo(contactsMap);
        
        // CREATE ICON
        let poi = L.icon({
          iconUrl: poiIcon,
          iconSize:     [28, 28],
          iconAnchor:   [14, 14]
        });
  
        // ADD POI TO MAP
        locations.forEach(location => {
          // ADD MAP POIs
          L.marker([location[0], location[1]], { icon: poi }).addTo(contactsMap);
        })
      }
    }
  }
}

const initMapTriggers = () => {
  const contactsMaps = document.querySelectorAll('[data-map]');
  const triggers = document.querySelectorAll('[data-map-trigger]');

  if(triggers?.length > 0 && contactsMaps?.length > 0)
  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const triggerLat = trigger.dataset.lat;
      const triggerLng = trigger.dataset.lng;
      window.dispatchEvent(new Event('resize'));
      if(triggerLat && triggerLng) {
        contactsMap.setView([triggerLat, triggerLng], 12);
      }
    });
  });
}

window.addEventListener('DOMContentLoaded', () => {
  initContactsMap();
  initMapTriggers();
})